module.exports = __webpack_public_path__ + "img/photo-0128.c7e4c591.jpg";